import { Injectable } from '@angular/core';
import { HttpClient,HttpHeaders } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';
import * as CryptoJS from 'crypto-js';
import { sha256, sha224 } from 'js-sha256';
import { ServerConstantsService } from './serverConstants.service';

@Injectable()
export class LoginService {
  serverConst:any;
  monthlyBenefit = 0;
  maxWage = 0;
  personId = 0;
  staticData = new Map();
  firstName = '';
  lastName = '';
  participationCode = 'SNAP RTW/Workfare';
  googleCaptcha:Boolean = false;
  loader:Boolean = false;
  workerPortal:any='';
  workerPortalTask:any='';
  survey:Boolean = false;
  link:any;
  requestType:any=null;

  constructor( public http:HttpClient,public toastService:ToastrService,private serverConstantsService: ServerConstantsService) {
    this.serverConst = ServerConstantsService.serverConstants.citizenUrl;
    this.googleCaptcha = ServerConstantsService.serverConstants.googleCaptcha;
    this.workerPortal = ServerConstantsService.serverConstants.workerportal;
    this.workerPortalTask = ServerConstantsService.serverConstants.workerPortalTask;    
    console.log('login.service load');
    this.load();
   }
   public load(){

    console.log('START ============== login.service.ts::load');
    let key = sha256(ServerConstantsService.serverConstants.privateKey).toString();
    console.log('key : ' + key);
    this.personId = (sessionStorage.getItem('id') !== undefined && sessionStorage.getItem('id') !== null) ? parseInt(CryptoJS.AES.decrypt(sessionStorage.getItem('id'), key).toString(CryptoJS.enc.Utf8)) : null;
    console.log('this.personId : ' + this.personId);
    this.getstaticData().subscribe((data:Array<Object>)=>{
      data.forEach((element)=>{
        this.staticData.set(element["name"],JSON.parse(element["data_value"]).EN);
      });
      let dt:any;
      this.survey = false;
      this.staticData.get('SurveyLinks').forEach((element)=>{
        let beginDt = new Date(new Date(element.activeBeginDt).toDateString());
        let endDt = new Date(new Date(element.activeEndDt).toDateString());
        let tdy = new Date(new Date().toDateString());
        if((beginDt <= tdy) && (endDt >= tdy) && (element.activeSW == 'Y')){
          this.survey = true;
          if((dt == undefined) || (dt > new Date(element.activeEndDt))){
            dt = new Date(element.activeEndDt).toDateString();
            this.link = element.name;
          }
        }
      })
      this.staticData.get('MINIMUMWAGE').forEach((element)=>{
        if(parseFloat(element.name.replace("$","").trim()) > this.maxWage){
          this.maxWage = parseFloat(element.name.replace("$","").trim());
          sessionStorage.setItem('maxwage',CryptoJS.AES.encrypt(this.maxWage.toString(),key).toString());
        }
        else{
          sessionStorage.setItem('maxwage',CryptoJS.AES.encrypt(this.maxWage.toString(),key).toString());
        }
      })
    },error=>{
      this.toastService.error("Unable to load static data","Static Data");
    }) 
    console.log('END ============== login.service.ts::load');
   } 
  public getstaticData(){
    return this.http.get(this.serverConst+"/getStatic");
  }
  public getSecurityQuestions(){
    let headers = new HttpHeaders();
            headers.append('Access-Control-Allow-Origin', '*');
            headers.append('content-type', 'application/json');
    return this.http.get(this.serverConst+"/tasks",{headers:headers});
  }
  public signUp(details){
    return this.http.post(this.serverConst + "/tasks",details);
  }
  public authenticate(details){
    return this.http.post(this.serverConst + "/authenticate",details);
  }
  public forgotPassword(details){
    return this.http.post(this.serverConst + "/forgotPassword",details);
  }
  public getproviderInfo(details){
    return this.http.post(this.serverConst + "/getproviderInfo",details);
  }
  public getuser(id){
    console.log('START ============= login.service.ts::getuser ID : ' + id);
    return this.http.get(this.serverConst + "/users/"+ id);
  }

  public getAriesuser(id){
    console.log('START ============= login.service.ts::getAriesuser ID : ' + id);
    return this.http.get(this.serverConst + "/usersforAries/"+ id);
  }
  public updateuser(id,details){
    return this.http.post(this.serverConst + "/users/"+ id,details);
  }
  public sendVerification(details){
    return this.http.post(this.serverConst + "/sendVerification/",details);
  }
  public sendEmail(details){
    return this.http.post(this.serverConst + "/sendEmail/",details);
  }
  public lockUser(details){
    return this.http.post(this.serverConst + "/lockUser/",details);
  }
  public fileUpload(formData){
    return this.http.post(this.serverConst+'/fileUpload',formData);
  }
  public saveworkfare(request){
    return this.http.post(this.serverConst+'/workfare/save',request);
  }
  public loadworkfare(request){
    return this.http.post(this.serverConst+'/workfare/load',request);
  }
  public getworkfare(id){
    return this.http.get(this.serverConst+'/workfare/load/'+id);
  }
  public finalize(request){
    return this.http.post(this.serverConst+'/workfare/finalize',request);
  }
  public componentSummary(request){
    return this.http.post(this.serverConst+'/component/load',request);
  }
  public updateHours(){
    return this.http.get(this.serverConst+'/update/'+this.personId);
  }
  public saveComponent(request){
    return this.http.post(this.serverConst+'/component/save',request);
  }
  public saveDocuments(request){
    return this.http.post(this.serverConst+'/documents/save',request);
  }
  public loadDocuments(request){
    return this.http.post(this.serverConst+'/documents/load',request);
  }
  public saveTask(request){
    return this.http.post(this.serverConst+'/saveTask',request);
  }
  public loadTasks(request){
    return this.http.post(this.serverConst+'/loadTasks',request);
  }
  public savegoodCause(request){
    return this.http.post(this.serverConst+'/save/goodCause',request);
  }

  public saveNoncompliance(request){
   // console.log("=== saveNoncompliance to workerportal bachedn====");
    console.log("this.workerPortal=="+this.workerPortal);
   let headers = new HttpHeaders();
   headers.append('Access-Control-Allow-Origin', '*');
   headers.append( 'Content-Type', 'application/json');
  
    return this.http.post(this.workerPortal+'/save/goodCauseCitizen',request,{headers:headers});
  }
  public loadAppointment(request){
    return this.http.post(this.serverConst+'/load/apptDate',request);
  }
  public loadAlerts(request){
    return this.http.post(this.serverConst+'/load/alerts',request);
  }
  public loadAlertshistory(request){
    return this.http.post(this.serverConst+'/alerts/history',request);
  }
  public updateAlerts(request){
    return this.http.post(this.serverConst+'/update/alerts', request);
  }
  public loadAppointments(request){
    return this.http.post(this.serverConst+'/load/appointments',request);
  }
  public enrollmentSummary(request){
    return this.http.post(this.serverConst+'/load/enrollment',request);
  }
  public loaddashboard(request){
    return this.http.post(this.serverConst+'/load/dashboard',request);
  }
  public getParticipation(request){
    return this.http.post(this.serverConst+'/load/participation',request);
  }
  public getClientinfo(request){
    console.log('START ============== login.service.ts::getClientinfo request : ' + request);
          let headers = new HttpHeaders();
            headers.append('Access-Control-Allow-Origin', '*');
            headers.append( 'Content-Type', 'application/json');
            //headers.append('content-type', 'application/json');
            //headers: new HttpHeaders({        'Content-Type':  'application/json',        'Authorization': 'Bearer ' + token      })
    return this.http.get(this.workerPortal+'/GetCitizenClientInfo/'+request.ssn,{headers:headers});
  }

  public decodeToken(request){
    console.log('START ============== login.service.ts::decodeToken request : ' + request);
    let headers = new HttpHeaders();
      headers.append('Access-Control-Allow-Origin', '*');
      //headers.append('content-type', 'application/json');
    console.log('Invoking backend /OIDCAuthentication/');
return this.http.post(this.workerPortal+'/OIDCAuthentication/'+request,{headers:headers});
}

public getClietinfoAries(request){
  console.log('START ============== login.service.ts::getClietinfoAries request : ' + request);
  let headers = new HttpHeaders();
            headers.append('Access-Control-Allow-Origin', '*');
            //headers.append('content-type', 'application/json');
  console.log('Invoking backend /Aries/'+request.type+'/'+request.value,{headers:headers});
    return this.http.get(this.workerPortal+'/Aries/'+request.type+"/"+request.value,{headers:headers});
}
  public getInformation(request){
    return this.http.post(this.serverConst+'/getInfo',request);
  }
  public checkUsername(request){
    return this.http.post(this.serverConst+'/getInfo/checkUsername',request);
  }
}



// WEBPACK FOOTER //
// ./src/app/login.service.ts